import { getResultDataLinkEvent } from '../../_helpers/search-bar-data-link-events';
import { Autocomplete } from '../../SearchBarProps';
import { useComponentContext } from '../../../_helpers/componentContext.tsx';

type AutocompleteItemProps = {
	result: Autocomplete;
	searchInput: string;
	selected: boolean;
};

const AutocompleteItem: React.FC<AutocompleteItemProps> = ({
	result,
	searchInput,
	selected = false,
}) => {
	const componentName = useComponentContext().componentName;
	return (
		<li className="autocomplete-item">
			<a
				className={`autocomplete-item-wrapper ${selected ? 'selected' : ''}`}
				tabIndex={-1}
				href={result.id}
				aria-label={result.label}
				data-link-event={getResultDataLinkEvent(
					componentName,
					searchInput,
					result
				)}
				data-final-url
			>
				{result.label}
			</a>
		</li>
	);
};
export default AutocompleteItem;
